"use strict";

canopyPublic.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	$stateProvider.state("public.register-complete", {
		url: "/register-complete",
		controller: "RegisterCompleteController",
		templateUrl: Luma.paths.context + "/system/mantle/components/canopyPublic/states/register-complete/register-complete.template.html"
	});
}]);
